import TagsInput from 'lib/ui/form/TagsInput'
import Skeleton from '@material-ui/lab/Skeleton'
import React, {useCallback} from 'react'
import {Tags} from 'Event/attendee'
import {Widget} from 'Event/Widget/template'

export default function TagsConfig(props: {
  widget: Widget | null
  updateWidget: (updatedFields: Partial<Widget>) => void
}) {
  const {widget, updateWidget} = props

  const setTags = useCallback(
    (tags: Tags) => {
      updateWidget({tags})
    },
    [updateWidget],
  )

  if (!widget) {
    return <Skeleton height={56} />
  }

  return (
    <TagsInput
      value={widget.tags}
      onChange={setTags}
      name="tags"
      aria-label="tags"
      label="Tags"
    />
  )
}
